"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Caret = function Caret(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 30 30",
    fill: "none"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("rect", {
    width: "30",
    height: "30",
    fill: props.backgroundColor
  }), _react.default.createElement("path", {
    d: "M22.6699 12.2948L16.5091 20.0391C15.9247 20.7476 15.0238 20.7476 14.4637 20.0391L8.30297 12.2948C7.71856 11.5619 8.01077 11 8.91174 11H22.0611C22.9864 11 23.2543 11.5619 22.6699 12.2948Z",
    fill: props.foregroundColor
  }));
};

Caret.defaultProps = {
  altText: "Caret",
  backgroundColor: "#2D5AB4",
  foregroundColor: "#FFFFFF"
};
Caret.propTypes = {
  altText: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = Caret;
exports.default = _default;